import { useState } from 'react'
import { useTriggerRequest } from './useTriggerRequest'

export function useQueryApi({
  endpoint,
  enable = true,
  callbackFn,
  dependency
}) {
  const [isLoading, setIsLoading] = useState(false)

  const { data } = useTriggerRequest({
    queryKey: [endpoint, dependency],
    endpoint,
    options: {
      enabled: enable,
      onInit: () => {
        setIsLoading(true)
      },
      onSuccess: (data) => {
        if (!callbackFn) {
          return
        }
  
        callbackFn(data)
      },
      onError: (error) => {
        console.error('Data fetching error:', error)
      },
      onSettled: () => {
        setIsLoading(false)
      }
    },
  })

  return {
    data,
    isLoading
  }
}
